<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <HubSpotForm
      class="greenhouse-panel"
      form-id="02639a53-6a0f-48a2-9c02-deaa97340f2a"
    />
  </div>
</template>

<script>
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';
import HubSpotForm from '@/components/settings/integrations/HubSpotForm.vue';

export default {
  name: 'GreenhouseSettings',
  components: {
    IntegrationConfigCard,
    HubSpotForm,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
  .greenhouse-panel {
    width: calc(50% - 6px);
  }
</style>
